import { render, staticRenderFns } from "./ProductCustomsCodes.vue?vue&type=template&id=286e46eb&"
import script from "./ProductCustomsCodes.vue?vue&type=script&lang=js&"
export * from "./ProductCustomsCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports